document.addEventListener('DOMContentLoaded', () => {
    const questions = document.querySelectorAll('.questions__question');
    const questionTitles = document.querySelectorAll('.questions__question .question__title');
    questionTitles.forEach((title, index) => {
        title.addEventListener('click', () => {
            const answearWrapper = questions[index]?.querySelector('.question__answear');
            if (questions[index].classList.toggle('opened')) {
                const answear = questions[index]?.querySelector('.question__answear .answear__wrapper');
                if (answearWrapper && answear)
                    answearWrapper.style.maxHeight = `${answear.offsetHeight}px`;
            }
            else {
                answearWrapper.style.maxHeight = '0px';
            }
        });
    });
});